import { action } from 'satcheljs/lib/legacy';
import getDefaultOptions, { DefaultOptionsType } from '../data/defaultOptions';
import getStore from '../store/store';

const assign = require('object-assign');

export default action('applyDefaultOptions')(function applyDefaultOptions(
    defaultOptions: DefaultOptionsType = getDefaultOptions()
) {
    Object.keys(getStore().options).forEach(featureKey => {
        if (!getStore().options[featureKey].lastModifiedDateTime) {
            // No value was loaded from the service
            // Apply the default option if it exists
            if (defaultOptions[featureKey]) {
                assign(getStore().options[featureKey], defaultOptions[featureKey]);
            }
        }
    });
});
